module.exports = __webpack_public_path__ + "068e46300db9a76878f336dde7368028.svg";